export default __webpack_public_path__ + "static/step_5_ru-2448ef12fd340a8a58de6d442c2692f3.svg";